import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { MiErrorComponent } from '../mi-error/mi-error.component';
import { MiFieldsComponent } from '../mi-fields/mi-fields.component';
import { MiTooltipComponent } from '../mi-fields/mi-tooltip/mi-tooltip.component';
import { AppSettings } from '../../app.settings';

@Component({
  selector: 'app-two-column-structure',
  templateUrl: './two-column-structure.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MiTooltipComponent,
    MiFieldsComponent,
    MiErrorComponent,
  ]
})
export class TwoColumnStructureComponent implements OnInit {
  @Input() field: any;
  @Input() attributeLabels: any;
  @Input() moduleName: string;
  @Input() dateFormat: string;
  @Input() multiSelectDisplay: any;
  @Input() showHrLine: boolean = true;

  constructor(public cs: CommonBindingDataService) { }

  ngOnInit() {
    this.moduleName = location.href.includes('app/settings/notification-settings') ? AppSettings.ENTITY_TYPE.NOTIFICATION_SETTINGS : this.moduleName;
  }
} 